import React from 'react';

const Loading = (props) => {
    return (
        <div className="viewer-image-loading">
        </div>
    );
};

export default Loading;